import { SvgIcon, type SvgIconProps } from './svgIcon'

export const DownloadIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 7L9 12M9 12L4 7M9 12L9 0"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M0 12H18V17H0V12Z" />
      <path
        d="M18 17V18.5H19.5V17H18ZM0 17H-1.5V18.5H0V17ZM16.5 12V17H19.5V12H16.5ZM18 15.5H0V18.5H18V15.5ZM1.5 17V12H-1.5V17H1.5Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_1_69)"
      />
    </svg>
  </SvgIcon>
)
